/**
 * Sticky Navigation
 *
 * Adds a sticky class to the nav_bottom element when scrolling on desktop
 */

export default function initStickyNav() {
  const navBottom = document.querySelector(".nav_bottom");
  const navTop = document.querySelector(".nav_top");

  if (!navBottom || !navTop) return;

  let scrollThreshold = 0;
  let isSticky = false;

  // Calculate the scroll threshold (when nav_top goes out of view)
  function updateScrollThreshold() {
    // Only apply on desktop (1024px and up based on your app.js)
    if (window.innerWidth < 1024) {
      if (isSticky) {
        navBottom.classList.remove("is-sticky");
        isSticky = false;
      }
      return;
    }

    scrollThreshold = navTop.offsetHeight;
  }

  // Handle scroll event
  function handleScroll() {
    // Skip on mobile
    if (window.innerWidth < 1024) return;

    const scrollPosition = window.scrollY || window.pageYOffset;

    if (scrollPosition > scrollThreshold && !isSticky) {
      navBottom.classList.add("is-sticky");
      isSticky = true;
    } else if (scrollPosition <= scrollThreshold && isSticky) {
      navBottom.classList.remove("is-sticky");
      isSticky = false;
    }
  }

  // Initialize
  updateScrollThreshold();

  // Event listeners
  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", updateScrollThreshold);

  // Initial check in case page loads scrolled
  handleScroll();
}
